// extracted by css-extract-rspack-plugin
export default {"Flash":"use-confirm-delete-field-values-module__Flash__rr9wsjG"};